// extracted by mini-css-extract-plugin
module.exports = {"container":"avatar_container__vz74j","dropdown":"avatar_dropdown__pWFa5","show":"avatar_show__TL4jq","divider":"avatar_divider__sEq_G"};